webpackJsonp([35783957827783],{

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(58);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactOverdrive = __webpack_require__(15);
	
	var _reactOverdrive2 = _interopRequireDefault(_reactOverdrive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardItem = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	  displayName: 'Card__CardItem'
	})(['min-height:500px;position:relative;overflow:hidden;border:10px solid #000;display:flex;flex-direction:column;justify-content:space-between;color:#fff;&:after{content:\'\';position:absolute;display:block;width:100%;height:100%;left:0;right:0;bottom:0;background:linear-gradient( to bottom,rgba(0,0,0,0.75) 0%,rgba(0,0,0,0) 20%,rgba(0,0,0,0) 80%,rgba(0,0,0,0.75) 100% );opacity:0;}&:hover{color:#fff!important;&:after{opacity:1;}}@media (max-width:768px){&:after{opacity:1!important;}}']);
	
	var Cover = _styledComponents2.default.div.withConfig({
	  displayName: 'Card__Cover'
	})(['width:100%;height:100%;position:absolute;div{overflow:hidden;}']);
	
	var Header = _styledComponents2.default.div.withConfig({
	  displayName: 'Card__Header'
	})(['display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;padding:1rem;z-index:10;opacity:0;@media (max-width:768px){opacity:1;}', ':hover &{opacity:1;}'], CardItem);
	
	var DateWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'Card__DateWrapper'
	})(['font-size:0.9rem;']);
	
	var Data = _styledComponents2.default.div.withConfig({
	  displayName: 'Card__Data'
	})(['z-index:10;position:relative;width:100%;']);
	
	var Content = _styledComponents2.default.div.withConfig({
	  displayName: 'Card__Content'
	})(['padding:1rem;position:relative;opacity:0;@media (max-width:768px){opacity:1;}', ':hover &{opacity:1;}'], CardItem);
	
	var Areas = _styledComponents2.default.span.withConfig({
	  displayName: 'Card__Areas'
	})(['font-size:0.75rem;']);
	
	var AreaItem = _styledComponents2.default.span.withConfig({
	  displayName: 'Card__AreaItem'
	})(['&:not(:last-child){margin-right:0.25rem;&:after{content:\',\';}}']);
	
	var Name = _styledComponents2.default.h2.withConfig({
	  displayName: 'Card__Name'
	})(['text-transform:uppercase;margin-top:1.25rem;margin-bottom:0;']);
	
	var Card = function Card(_ref) {
	  var path = _ref.path,
	      cover = _ref.cover,
	      date = _ref.date,
	      areas = _ref.areas,
	      title = _ref.title,
	      slug = _ref.slug;
	  return _react2.default.createElement(
	    CardItem,
	    { to: path },
	    _react2.default.createElement(
	      Cover,
	      null,
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: cover })
	    ),
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(
	        DateWrapper,
	        null,
	        date
	      ),
	      _react2.default.createElement(
	        Areas,
	        null,
	        areas.map(function (area) {
	          return _react2.default.createElement(
	            AreaItem,
	            { key: area },
	            area
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      Data,
	      null,
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(
	          Name,
	          null,
	          title
	        )
	      )
	    )
	  );
	};
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactOverdrive = __webpack_require__(15);
	
	var _reactOverdrive2 = _interopRequireDefault(_reactOverdrive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Test = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__Test'
	})(['background-color:red;display:flex;position:relative;']);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__Wrapper'
	})(['background-image:url("', '");display:flex;position:relative;'], function (props) {
	  return props.theme.bgPattern;
	});
	
	var Content = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__Content'
	})(['margin:0 auto;max-width:', ';padding:3rem 1.0875rem 10rem 1.0875rem;color:', ';text-align:center;'], function (props) {
	  return props.theme.maxWidths.general;
	}, function (props) {
	  return props.theme.colors.secondary;
	});
	
	var Avatar = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__Avatar'
	})(['height:125px;width:125px;margin:0 auto;image-rendering:-moz-crisp-edges;image-rendering:-o-crisp-edges;image-rendering:-webkit-optimize-contrast;-ms-interpolation-mode:nearest-neighbor;img{border-radius:50%;}']);
	
	var Name = _styledComponents2.default.h1.withConfig({
	  displayName: 'Header__Name'
	})(['text-transform:uppercase;font-weight:bold;margin:1rem 0 0.25rem 0;color:', ';'], function (props) {
	  return props.theme.colors.color;
	});
	
	var Location = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__Location'
	})(['font-size:0.9rem;display:flex;align-items:center;justify-content:center;']);
	
	var SocialMedia = _styledComponents2.default.div.withConfig({
	  displayName: 'Header__SocialMedia'
	})(['margin-top:2rem;a{margin:0 0.3rem;}']);
	
	var Header = function Header(_ref) {
	  var avatar = _ref.avatar,
	      name = _ref.name,
	      location = _ref.location,
	      socialMedia = _ref.socialMedia;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        _react2.default.createElement(
	          Avatar,
	          null,
	          _react2.default.createElement('img', { src: avatar, alt: name })
	        ),
	        _react2.default.createElement(
	          Name,
	          null,
	          name
	        )
	      ),
	      _react2.default.createElement(
	        Location,
	        null,
	        location
	      ),
	      _react2.default.createElement(
	        SocialMedia,
	        null,
	        socialMedia.map(function (social) {
	          return _react2.default.createElement(
	            'a',
	            { key: social.name, href: social.url, rel: 'noopener noreferrer', target: '_blank' },
	            social.name
	          );
	        }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/about' },
	          'About'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact' },
	          'Contact'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Card = __webpack_require__(38);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Header = __webpack_require__(39);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _site = __webpack_require__(12);
	
	var _site2 = _interopRequireDefault(_site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Grid = _styledComponents2.default.div.withConfig({
	  displayName: 'pages__Grid'
	})(['display:grid;grid-template-columns:repeat(', ',1fr);grid-gap:50px;@media (max-width:768px){grid-template-columns:1fr;}.gatsby-image-outer-wrapper,.gatsby-image-wrapper{position:static !important;}'], function (props) {
	  return props.theme.gridColumns;
	});
	
	var Content = _styledComponents2.default.div.withConfig({
	  displayName: 'pages__Content'
	})(['margin:-6rem auto 6rem auto;max-width:', ';padding:0 ', ' 1.45rem;position:relative;'], function (props) {
	  return props.theme.maxWidths.general;
	}, function (props) {
	  return props.theme.contentPadding;
	});
	
	var Index = function Index(_ref) {
	  var edges = _ref.data.allMarkdownRemark.edges;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_Header2.default, { avatar: _site2.default.avatar, name: _site2.default.name, location: _site2.default.location, socialMedia: _site2.default.socialMedia }),
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        Grid,
	        null,
	        edges.map(function (project) {
	          return _react2.default.createElement(_Card2.default, {
	            date: project.node.frontmatter.date,
	            title: project.node.frontmatter.title,
	            cover: project.node.frontmatter.cover.childImageSharp.sizes,
	            path: project.node.fields.slug,
	            areas: project.node.frontmatter.areas,
	            slug: project.node.fields.slug,
	            key: project.node.fields.slug
	          });
	        })
	      )
	    )
	  );
	};
	
	exports.default = Index;
	
	/* eslint no-undef: off */
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-53ace226f0169cb37a37.js